import { Id, retrieveEventError } from "@planzone/dto";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (eventId: Id) =>
    present(
      repository
        .getEvent(eventId)
        .catch((e) =>
          Promise.reject({ error: { ...retrieveEventError, ...e }, eventId }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
